import React, {Component} from 'react'
import PropTypes from 'prop-types'

class LabelType extends Component {
    render() {
        return (
            <td className='LabelType'>
                {this.props.type}
            </td>
        )
    }
}

LabelType.propTypes = {
    type: PropTypes.string.isRequired,
}

export default LabelType
